module.exports = __webpack_public_path__ + "static/media/sCrt.3706eb1d.png";